import styled from "@emotion/styled";
import React from "react";
import { SelectItem } from "../../../lib/types/SelectItem";
import { useColorMode } from "@chakra-ui/react";

const OptionListItem = (props: {
  item: SelectItem;
  index: number;
  onClick: (e: any, index: number) => void;
  hasFocus: boolean;
  isSelected: boolean;
}) => {
  const { item, index, hasFocus, isSelected, onClick } = props;

  const itemRef = React.useRef<HTMLLIElement>(null);

  const { colorMode } = useColorMode();

  return (
    <ListItem
      className={`${hasFocus ? "active" : ""} ${isSelected ? "selected" : ""}`}
      ref={itemRef}
      tabIndex={-1}
      onMouseDown={(e: any) => onClick(e, index)}
      colorMode={colorMode}
    >
      {item.label}
    </ListItem>
  );
};

const ListItem = styled.li<{ colorMode: string }>`
  padding: 0.5rem;
  cursor: pointer;

  &:hover {
    background: ${(props) =>
      props.colorMode === "light"
        ? "var(--chakra-colors-gray-50)"
        : "var(--chakra-colors-gray-600)"};
  }

  &.selected {
    background: var(--chakra-colors-blue-50);
    background: ${(props) =>
      props.colorMode === "light"
        ? "var(--chakra-colors-blue-50)"
        : "var(--chakra-colors-blue-500)"};
  }

  &.active {
    background: ${(props) =>
      props.colorMode === "light"
        ? "var(--chakra-colors-gray-100)"
        : "var(--chakra-colors-gray-600)"};
  }
`;

export default OptionListItem;
